import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import _get from 'lodash/get';

import Button from '@material-ui/core/Button';

const styles = theme => {
  return {
    button: {
      fontSize: 14.6,
      lineHeight: 1.1,
      letterSpacing: 1.25,
      marginBottom: theme.spacing(1),
      width: 265,
      height: 39,
      fontWeight: 'bold',
      marginTop: theme.spacing(1),
    },
  };
};

class StandardButton extends React.PureComponent {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    color: PropTypes.string,
    match: PropTypes.object,
    history: PropTypes.object,
  };

  handleStandardLogin = () => {
    const { match, history } = this.props;
    history.push(`/standard/${_get(match, 'params.id')}`, 0);
  };

  render() {
    const { classes, color } = this.props;
    return (
      <Button
        className={classes.button}
        variant="outlined"
        onClick={this.handleStandardLogin}
        color={color}
      >
        Use Standard Login
      </Button>
    );
  }
}

export default withStyles(styles)(StandardButton);
